/* sd-vrx.js - behaviours for the VRX pages.
   1. Sticky offsets: measures the theme header and the VRX sub-nav so the
      turntable pins below them instead of under them.
   2. Stage: the scroll-driven picture rail on every rig page (see below).
   3. Lightbox: any [data-vx-open] link opens its href in a <dialog>.
   4. Brief form: fills the hidden product field from the page, and
      brings a returned "sent" state into view.
   Nothing here hides content before it runs. */
(function () {
  'use strict';
  var root = document.documentElement;
  var raf = window.requestAnimationFrame || function (f) { return setTimeout(f, 16); };

  function measure() {
    var hdr = document.querySelector('.sd-hdr, .sd-header, header[class*="sd-hdr"]');
    var hh = 0;
    if (hdr) {
      var cs = getComputedStyle(hdr);
      if (cs.position === 'sticky' || cs.position === 'fixed') hh = hdr.getBoundingClientRect().height;
    }
    var nav = document.querySelector('.vx-nav');
    var nh = nav ? nav.getBoundingClientRect().height : 0;
    root.style.setProperty('--vx-hdr', Math.round(hh) + 'px');
    root.style.setProperty('--vx-pin-top', Math.round(hh + nh + 20) + 'px');
  }
  measure();
  window.addEventListener('resize', function () { raf(measure); });
  window.addEventListener('load', measure);

  /* ---- sub-nav on phones: bring the current page's link into view ---- */
  (function () {
    var ul = document.querySelector('.vx-nav__links');
    var a = ul && ul.querySelector('[aria-current="page"]');
    if (!a || ul.scrollWidth <= ul.clientWidth) return;
    ul.scrollLeft += (a.getBoundingClientRect().left - ul.getBoundingClientRect().left) - (ul.clientWidth - a.offsetWidth) / 2;
  })();

  /* ---- stage (the scroll-driven picture rail) ----
     Every rig page has one. While the section scrolls past, the picture
     and its index entry follow scroll progress. Arrows step by hand and
     are the only control on phones and under reduced motion, where
     nothing pins. Clicking the picture opens it in the lightbox. */
  var stageLightbox = null;
  Array.prototype.forEach.call(document.querySelectorAll('[data-vx-stage]'), function (st) {
    var imgs = st.querySelectorAll('[data-vx-angle]');
    var items = st.querySelectorAll('[data-vx-item]');
    var btns = st.querySelectorAll('[data-vx-go]');
    var prev = st.querySelector('[data-vx-prev]'), next = st.querySelector('[data-vx-next]');
    var bar = st.querySelector('[data-vx-bar]');
    var cap = st.querySelector('[data-vx-caption]');
    var count = st.querySelector('[data-vx-count]');
    var plate = st.querySelector('[data-vx-open-stage]');
    var n = imgs.length, cur = -1, manual = false, ticking = false;
    if (!n) return;
    function pad(i) { return (i < 9 ? '0' : '') + (i + 1); }
    function go(i) {
      i = (i + n) % n;
      if (i === cur) return;
      cur = i;
      Array.prototype.forEach.call(imgs, function (im, k) { im.classList.toggle('is-on', k === i); });
      Array.prototype.forEach.call(items, function (el, k) { el.classList.toggle('is-on', k === i); });
      Array.prototype.forEach.call(btns, function (b, k) { b.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
      if (cap && imgs[i].getAttribute('alt')) cap.textContent = imgs[i].getAttribute('alt');
      if (count) count.textContent = pad(i) + ' / ' + pad(n - 1);
      if (bar && manual) bar.style.setProperty('--p', ((i + 1) / n * 100).toFixed(1) + '%');
    }
    function pinned() { return st.offsetHeight - window.innerHeight > 40 && getComputedStyle(st.querySelector('.vx-stage__pin')).position === 'sticky'; }
    function onScroll() {
      ticking = false;
      if (!pinned()) { if (cur < 0) go(0); return; }
      if (manual) return;
      var r = st.getBoundingClientRect();
      var total = st.offsetHeight - window.innerHeight;
      var p = Math.min(1, Math.max(0, -r.top / total));
      if (bar) bar.style.setProperty('--p', (p * 100).toFixed(1) + '%');
      go(Math.min(n - 1, Math.floor(p * n)));
    }
    Array.prototype.forEach.call(btns, function (b, k) { b.addEventListener('click', function () { manual = true; go(k); }); });
    if (prev) prev.addEventListener('click', function () { manual = true; go(cur - 1); });
    if (next) next.addEventListener('click', function () { manual = true; go(cur + 1); });
    // Index entries that are not links step the rail too.
    Array.prototype.forEach.call(items, function (el, k) {
      if (el.querySelector('a')) return;
      el.addEventListener('click', function () { manual = true; go(k); });
    });
    if (plate) plate.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('a, button')) return;
      var im = imgs[Math.max(0, cur)];
      var full = im.getAttribute('data-full') || im.currentSrc || im.src;
      if (stageLightbox) stageLightbox(full, im.getAttribute('alt') || '');
    });
    window.addEventListener('scroll', function () {
      manual = false;
      if (!ticking) { ticking = true; raf(onScroll); }
    }, { passive: true });
    onScroll();
  });

  /* ---- lightbox ---- */
  var dlg = document.querySelector('[data-vx-lightbox]');
  if (dlg && typeof dlg.showModal === 'function') {
    var img = dlg.querySelector('img'), cap2 = dlg.querySelector('[data-vx-lb-caption]');
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('[data-vx-open]') : null;
      if (!a) return;
      e.preventDefault();
      img.src = a.getAttribute('href');
      img.alt = a.getAttribute('data-alt') || '';
      if (cap2) cap2.textContent = a.getAttribute('data-caption') || a.getAttribute('data-alt') || '';
      dlg.showModal();
    });
    stageLightbox = function (src, alt) {
      img.src = src; img.alt = alt;
      if (cap2) cap2.textContent = alt;
      dlg.showModal();
    };
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    var closeBtn = dlg.querySelector('[data-vx-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('close', function () { img.removeAttribute('src'); });
  }

  /* ---- swipe rows: arrows, a counter, and a tap on a picture opens it large ---- */
  Array.prototype.forEach.call(document.querySelectorAll('.vx-swipe'), function (row) {
    var tiles = Array.prototype.slice.call(row.children);
    var pics = row.classList.contains('vx-tiles');
    var n = tiles.length;
    if (!n) return;
    var ctl = document.createElement('div');
    ctl.className = 'vx-swipe__ctl';
    ctl.innerHTML = '<button type="button" class="vx-stage__arrow" data-vx-dir="-1" aria-label="Previous">&larr;</button>' +
      '<span class="vx-stage__count" aria-live="polite"></span>' +
      '<button type="button" class="vx-stage__arrow" data-vx-dir="1" aria-label="Next">&rarr;</button>' +
      '<span class="vx-swipe__hint">' + (pics ? 'Swipe or use the arrows. Tap a picture to enlarge it.' : 'Swipe or use the arrows. Tap a sheet to read it full size.') + '</span>';
    row.parentNode.insertBefore(ctl, row.nextSibling);
    var prevB = ctl.querySelector('[data-vx-dir="-1"]'), nextB = ctl.querySelector('[data-vx-dir="1"]');
    var cnt = ctl.querySelector('.vx-stage__count');
    row.setAttribute('tabindex', '0');
    row.setAttribute('role', 'region');
    if (!row.getAttribute('aria-label')) row.setAttribute('aria-label', (pics ? 'Pictures' : 'Sheets') + ': swipe or use the arrows');
    function pad(i) { return (i < 9 ? '0' : '') + (i + 1); }
    function step() { return n > 1 ? tiles[1].offsetLeft - tiles[0].offsetLeft : row.clientWidth; }
    function update() {
      var max = row.scrollWidth - row.clientWidth;
      ctl.hidden = max <= 4;
      var atEnd = row.scrollLeft >= max - 4;
      var i = atEnd ? n - 1 : Math.min(n - 1, Math.round(row.scrollLeft / step()));
      cnt.textContent = pad(i) + ' / ' + pad(n - 1);
      prevB.disabled = row.scrollLeft <= 4;
      nextB.disabled = atEnd;
    }
    ctl.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-vx-dir]') : null;
      if (!b) return;
      row.scrollBy({ left: step() * Number(b.getAttribute('data-vx-dir')) });
    });
    var raf = 0;
    row.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; update(); });
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
    row.addEventListener('click', function (e) {
      if (!stageLightbox || !e.target.closest || e.target.closest('a')) return;
      var im = e.target.closest('.vx-tile > .vx-plate img, .vx-tile > figure img');
      if (!im) return;
      var src = (im.currentSrc || im.getAttribute('src') || '').replace(/([?&])width=\d+/, '$1width=1800');
      stageLightbox(src, im.getAttribute('alt') || '');
    });
  });

  /* ---- venue scenario (arithmetic, not a forecast) ---- */
  var calc = document.querySelector('[data-vx-calc]');
  if (calc) {
    var out = calc.querySelector('[data-vx-calc-out]');
    var err = calc.querySelector('[data-vx-calc-error]');
    var money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
    var runCalc = function () {
      var valid = calc.checkValidity();
      if (err) err.textContent = valid ? '' : 'Complete each input within its range to run the scenario.';
      if (out) out.hidden = !valid;
      if (!valid) return;
      var n = function (k) { return Number(calc.elements[k].value) || 0; };
      var revenue = n('price') * n('sessions') * n('days') * (52 / 12) * n('bays');
      var contribution = revenue * (1 - n('variable') / 100) - n('overhead');
      var cost = n('cost');
      var payback = cost === 0 ? 'Enter the equipment figure from your quote' : (contribution > 0 ? (cost / contribution).toLocaleString('en-US', { maximumFractionDigits: 1 }) + ' months' : 'Not recovered at this rate');
      var set = function (k, v) { var el = calc.querySelector('[data-vx-result="' + k + '"]'); if (el) el.textContent = v; };
      set('revenue', money.format(revenue)); set('contribution', money.format(contribution)); set('payback', payback);
    };
    calc.addEventListener('submit', function (e) { e.preventDefault(); runCalc(); });
    calc.addEventListener('input', runCalc);
    runCalc();
  }

  /* ---- brief form ---- */
  var brief = document.querySelector('[data-vx-brief]');
  if (brief) {
    var product = brief.getAttribute('data-vx-product');
    var sel = brief.querySelector('select[name="contact[product]"]');
    if (product && sel) {
      Array.prototype.forEach.call(sel.options, function (o) { if (o.value === product) sel.value = product; });
    }
    var use = brief.getAttribute('data-vx-use');
    var useSel = brief.querySelector('select[name="contact[use]"]');
    if (use && useSel) {
      Array.prototype.forEach.call(useSel.options, function (o) { if (o.value === use) useSel.value = use; });
    }
    var ok = brief.querySelector('.vx-form__ok');
    if (ok && /contact_posted=true/.test(location.search)) {
      try { ok.scrollIntoView({ block: 'center' }); ok.focus(); } catch (err) {}
    }
    // Any "start a project" link on the page can preselect a system.
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('[data-vx-pick]') : null;
      if (!a || !sel) return;
      var v = a.getAttribute('data-vx-pick');
      Array.prototype.forEach.call(sel.options, function (o) { if (o.value === v) sel.value = v; });
      var u = a.getAttribute('data-vx-use');
      if (u && useSel) Array.prototype.forEach.call(useSel.options, function (o) { if (o.value === u) useSel.value = u; });
    });
  }
})();
